module.exports = __webpack_public_path__ + "2d985f89b2854ded202ed8336df79ab9.svg";